const init = () => {
  window.addEventListener('resize', updateMenuAriaState);
  window.addEventListener('load', updateMenuAriaState);
  updateMenuAriaState();
}

const updateMenuAriaState = () => {
  const menu = document.getElementById('left-menu');
  const toggleButton = document.querySelector('[data-a11y-toggle="left-menu"]');

  if (!menu || !toggleButton) return;

  if (window.innerWidth > 992) {
    menu.setAttribute('aria-hidden', 'false');
    toggleButton.setAttribute('aria-expanded', 'true');
  } else {
    menu.setAttribute('aria-hidden', 'true');
    toggleButton.setAttribute('aria-expanded', 'false');
  }
}

const leftMenu = {
  init,
};

export default leftMenu;
